module.exports = __webpack_public_path__ + "static/mono-72-07ca499b7bdc625f2df54aedf3d3ebd8.png";